import SentList from "./SentList";

const SendRequest = () => {
  return <SentList />;
};

export default SendRequest;
